import { cloneDeep } from "lodash";
import { IEditorV3 } from "../classes/interface";

/**
 * Splits EditorV3 content into an array of individual line objects.
 * Each resulting object contains a single line with cloned properties to prevent mutation.
 *
 * @param value - The EditorV3 content to split into separate lines
 * @returns Array of IEditorV3 objects, each containing a single line
 */
export const splitV3intoLines = (value: IEditorV3): IEditorV3[] => {
  return value.lines.map((line) => ({
    lines: [cloneDeep(line)],
    contentProps: value.contentProps,
  }));
};
